import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=547575a6&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547575a6')) {
      api.createRecord('547575a6', component.options)
    } else {
      api.reload('547575a6', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=547575a6&", function () {
      api.rerender('547575a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/tree/src/tree.vue"
export default component.exports